/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./lang-select.vue?vue&type=template&id=1c08585a&scoped=true&"
import script from "./lang-select.vue?vue&type=script&lang=ts&"
export * from "./lang-select.vue?vue&type=script&lang=ts&"
import style0 from "./lang-select.vue?vue&type=style&index=0&id=1c08585a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08585a",
  null
  
)

export default component.exports